import { render, staticRenderFns } from "./ManageConsumptions.vue?vue&type=template&id=63eb3623&"
import script from "./ManageConsumptions.vue?vue&type=script&lang=js&"
export * from "./ManageConsumptions.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports